import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'

export default function SimulationMode() {
  return (
    <Card className="px-6 py-4">
      <div className="flex gap-6 items-center">
        <Image alt="" src="/images/img-simulation.png" width={94} height={84} />

        <Text variant="heading-md" className="flex-1 -ml-[10px]">
          Mari pelajari dan coba Penilaian Kinerja lewat simulasi!
        </Text>

        <Button
          as="a"
          color="white"
          size="lg"
          href={`${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/demo`}
        >
          Coba simulasi
          <Icon>chevron_right</Icon>
        </Button>
      </div>
    </Card>
  )
}
